var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotePencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 5.5H6C4.89543 5.5 4 6.39543 4 7.5V18.5C4 19.6046 4.89543 20.5 6 20.5H17C18.1046 20.5 19 19.6046 19 18.5V15.5M16.6716 7C17.4526 6.21895 18.719 6.21895 19.5 7C20.281 7.78105 20.281 9.04738 19.5 9.82843L12.8284 16.5H10L10 13.6716L16.6716 7Z",
    stroke: "#D1D5DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 9.5H10",
    stroke: "#D1D5DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotePencil);
export default __webpack_public_path__ + "static/media/notePencil.a170c84e991b9c6d19d1d218e8eaba6c.svg";
export { ForwardRef as ReactComponent };